import { useNavigate } from 'react-router';
import { useAuth } from '@/auth/AuthContext';
import { Card, CardBody, CardHeader } from '@/components/ui/card';
import { Alert } from '@/components/ui/feedback';
import { Button } from '@/components/ui/button';
import { ChangePasswordForm } from './ChangePasswordForm';
import { Brand } from '@/components/layout/Brand';

export default function ForceChangePasswordPage() {
  const { refresh, logout, user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-page px-4">
      <Brand />
      <Card className="w-full max-w-md">
        <CardHeader
          title="Đổi mật khẩu"
          description={`Xin chào ${user?.fullName}`}
          actions={
            <Button
              variant="ghost"
              size="sm"
              onClick={async () => {
                await logout();
                navigate('/dang-nhap');
              }}
            >
              Đăng xuất
            </Button>
          }
        />
        <CardBody className="space-y-4">
          <Alert tone="warning">Bạn cần đổi mật khẩu do quản trị viên cấp trước khi sử dụng hệ thống.</Alert>
          <ChangePasswordForm
            onDone={async () => {
              await refresh();
              navigate('/', { replace: true });
            }}
          />
        </CardBody>
      </Card>
    </div>
  );
}
